import { token } from '@/stores/token';
import { trace } from '@/utils/authTrace';

// Tri-state org-resolution fix, part 2 (2026-08-09) — orgResolution is
// persisted (localStorage), so a previously-resolved value from an earlier
// session on this same device/browser survives a logout and would
// otherwise leak straight into the NEXT login — e.g. a shared/kiosk device
// where user A (resolved-org) signs out and user B signs in: without this
// reset, B's guards would read A's stale 'resolved-org' (and A's
// organisationId) before B's own handleUserLogin has run.
//
// ?code=&state= is the standard Auth0 redirect-callback landing signature —
// same detection idiom already used for main.js's boot trace
// (hasCode/hasState). Every such landing is a genuinely new code exchange,
// so it's the correct, narrow trigger: it must NOT fire on ordinary
// navigations or reloads that aren't a login in progress, or a legitimately
// still-resolving state would be wiped out from under a pending lookup.
export function resetOrgResolutionOnFreshLogin(search = window.location.search) {
  if (search.includes('code=') && search.includes('state=')) {
    trace('fresh-redirect-callback-detected-reset-org-resolution');
    token().orgResolutionChange('unknown');
    return true;
  }
  return false;
}
